<style>

.splash{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("i/splash.jpg");
  background-size: cover;
  padding: 0;
  text-align: center;
}

.logo{
  margin-top: 40px;
  width: 200px;
}

.lower-third{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  
  background-image: linear-gradient( rgba(0,0,0,0.2), rgba(0,0,0,1) );
}

.spinner{
  margin-top: 40px;
}
.loading{
  color: rgba(255,255,255,1);
  font-size: 23px;
  /* text-align: center; */
}

.version{
  margin-top: 40px;
  color: rgba(255,255,255,0.5);
  font-size: 14px;
}

</style>

{#if $location == "/"}

<div class="splash">
  
  <img src="i/logo.svg" class="logo" alt="logo">
  
  <div class="lower-third">
    <div class="spinner">
      <Spinner></Spinner>
    </div>
    
    <div class="loading">
      <AwesomeSauce curMessage="{curMessage}"></AwesomeSauce>
    </div>
    <div class="version">v22.05.12 b127</div>
  </div>
</div>

{/if}

<Router {routes}/>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();
 
import Splash from "./pages/Splash.svelte";
import SignupPush from "./pages/SignupPush.svelte";
import Signup from "./pages/Signup.svelte";
import ValidateText from "./pages/ValidateText.svelte";
import ValidateEmail from "./pages/ValidateEmail.svelte";
import Login from "./pages/Login.svelte";
import Events from "./pages/Events.svelte";
import EventsFilter from "./pages/EventsFilter.svelte";
import EventsInfo from "./pages/EventsInfo.svelte";
import CreateNewEvent from "./pages/CreateNewEvent.svelte";
import BusinessProfile from "./pages/BusinessProfile.svelte";
import Profile from "./pages/Profile.svelte";
import EditProfile from "./pages/EditProfile.svelte";
import EditInterests from "./pages/EditInterests.svelte";
import EditQuestions from "./pages/EditQuestions.svelte";
import FindFriends from "./pages/FindFriends.svelte";
import Friends from "./pages/Friends.svelte";
import FriendProfile from "./pages/FriendProfile.svelte";
import Message from "./pages/Message.svelte";
import Search from "./pages/Search.svelte";
import AwesomeSauce from "./components/AwesomeSauce.svelte";
import Spinner from "./components/Spinner.svelte";
import EventFeedback from "./pages/EventFeedback.svelte"
import EventFeedback2 from "./pages/EventFeedback2.svelte"

// profile builder wizard
import Type from "./pages/wizard/profile/personal/Type.svelte";
import Name from "./pages/wizard/profile/personal/Name.svelte";
import Email from "./pages/wizard/profile/personal/Email.svelte";
import EmailVerify from "./pages/wizard/profile/personal/EmailVerify.svelte";
import Phone from "./pages/wizard/profile/personal/Phone.svelte";
import PhoneVerify from "./pages/wizard/profile/personal/PhoneVerify.svelte";
import Username from "./pages/wizard/profile/personal/Username.svelte";
import Password from "./pages/wizard/profile/personal/Password.svelte";
import Birthday from "./pages/wizard/profile/personal/Birthday.svelte";
import Gender from "./pages/wizard/profile/personal/Gender.svelte";
import AgePreference from "./pages/wizard/profile/personal/AgePreference.svelte";
import LookingForGender from "./pages/wizard/profile/personal/LookingForGender.svelte";
import DistanceAway from "./pages/wizard/profile/personal/DistanceAway.svelte";
import Photos from "./pages/wizard/profile/personal/Photos.svelte";
import AddInterests from "./pages/wizard/profile/personal/AddInterests.svelte";
import Questions from "./pages/wizard/profile/personal/Questions.svelte";
import ThankYou from "./pages/wizard/profile/personal/ThankYou.svelte";

// https://github.com/ItalyPaleAle/svelte-spa-router
import Router from 'svelte-spa-router';
import {push, pop, replace, location} from 'svelte-spa-router';

const routes = {
  "/": Splash,
  "/signupask": SignupPush,
  
  "/signup/profile/type": Type,
  "/signup/profile/personal/name": Name,
  "/signup/profile/personal/email": Email,
  "/signup/profile/personal/email-verify": EmailVerify,
  "/signup/profile/personal/phone": Phone,
  "/signup/profile/personal/phone-verify": PhoneVerify,
  "/signup/profile/personal/username": Username,
  "/signup/profile/personal/password": Password,
  "/signup/profile/personal/birthday": Birthday,
  "/signup/profile/personal/gender": Gender,
  "/signup/profile/personal/age-preference": AgePreference,
  "/signup/profile/personal/looking-for": LookingForGender,
  "/signup/profile/personal/distance-away": DistanceAway,
  "/signup/profile/personal/photos": Photos,
  "/signup/profile/personal/add-interests": AddInterests,
  "/signup/profile/personal/add-interests/:category": AddInterests,
  "/signup/profile/personal/questions": Questions,
  "/signup/profile/personal/thankyou": ThankYou,
  
  "/login": Login,
  "/events": Events,
  "/events-filter": EventsFilter,
  "/events-info/:oid": EventsInfo,
  "/create-new-event": CreateNewEvent,
  "/business-profile/:oid": BusinessProfile,
  "/profile": Profile,
  "/edit-profile": EditProfile,
  "/edit-interests": EditInterests,
  "/edit-interests/:category": EditInterests,
  "/edit-questions": EditQuestions,
  "/edit-questions/:question": EditQuestions,
  "/find-friends": FindFriends,
  "/friends": Friends,
  "/friend-profile/:oid": FriendProfile,
  "/message/:oid": Message,
  "/search": Search,
  "/eventfeedback": EventFeedback, 
  "/eventfeedback2": EventFeedback2, 
  
  // "/": ,
  
  
  // Catch-all
  // This is optional, but if present it must be the last
  // "*": NotFound,
}

export let ready = false;

// for splash updates
let handle = null;
let curMessage = 0;


import { onMount } from "svelte";
onMount(async () => {
  onDeviceReady();
});

// // from https://stackoverflow.com/a/10237209
// if ( navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry)/) && document.URL.indexOf("http://") === -1
//   && document.URL.indexOf("https://") === -1 ) {
//   console.log("on actual mobile device");
//   console.log("navigator.userAgent:", navigator.userAgent);
//   document.addEventListener("deviceready", onDeviceReady, false);
// } else {
//   onDeviceReady();
// }

function onDeviceReady() {
  ready = true;
  // fetch current data
  
  // pretend we've fetched data
  console.log("location:", $location)
  if ($location == "/") {
    handle = setInterval( () => {
      curMessage++;
      if (curMessage > 2) {
        clearInterval(handle);
        handle = setTimeout( () => {loggedIn()}, 1000);
      }
    }, 1500);
  }
    
}


// checks to see if a user is logged in.
// if so, then we forward the user to the proper page
// otherwise we forward them to the initial system
function loggedIn() {
  handle = null;
  curMessage = 0;
  replace("/signupask");
}

</script>